import React from 'react';
import PropTypes from 'prop-types';
import {Form, FormGroup, Label, Input} from 'reactstrap';

import {frefFromRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import LocalStorage from '../../../lib/tools/local-storage';
import OEToolbox from '../../../lib/tools/oe-toolbox-core';
import OEResizeObserver from '../../../lib/components/oe-resize-observer';
import OEStdModalController from '../../modals/oe-std-modal-controller';
import {OECustomCheckbox} from '../../elements/controls/oe-checkbox';
import {OEButtonControl} from '../../elements/controls/oe-controls';
import {OEBlurModalBackdropLayer} from '../oe-blur-layer';
import OETextView from '../text-view/oe-text-view';
import OECoreHideLayer from '../oe-core-hide-layer';
import OEThemeWaitingController from '../oe-theme-waiting-controller';
import {OEWelcomeViewProps, OEWelcomeViewConfigFactory} from './oe-welcome-view-model';
import OEUserService, {OEUserServiceResultType} from '../../../api/oe-user-service';

export class OERegisterView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.form = {
            name:                   '',
            email:                  '',
            institution:            ''
        };

        this.termsAccepted = false;
        this.privacyTermsAccepted = false;

        this.canSend = false;

        this.sizes = {};

        this.state = {
            termsAccepted:          this.termsAccepted,
            privacyTermsAccepted:   this.privacyTermsAccepted,
            canSend:                this.canSend,
            strings: {
                name:               'Name',
                email:              'Email',
                institution:        'Institution',
                acceptTerms:        'I accept the terms',
                sendBtn:            'Send'
            },
            style:                  {},
            privacyStyle:           {},
            willOpenAtStartUp:      false
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onFormResize = this.onFormResize.bind(this);
        this.onTextViewContentResize = this.onTextViewContentResize.bind(this);
        this.onPrivacyTextViewContentResize = this.onPrivacyTextViewContentResize.bind(this);
        this.onBottomResize = this.onBottomResize.bind(this);

        this.onWaitingControllerRef = this.onWaitingControllerRef.bind(this);
        this.onRef = this.onRef.bind(this);

        this.onNameInputChange = this.onNameInputChange.bind(this);
        this.onEmailInputChange = this.onEmailInputChange.bind(this);
        this.onInstitutionInputChange = this.onInstitutionInputChange.bind(this);

        this.onAcceptTermsClicked = this.onAcceptTermsClicked.bind(this);
        this.onPrivacyAcceptTermsClicked = this.onPrivacyAcceptTermsClicked.bind(this);
        this.onSendBtnPressed = this.onSendBtnPressed.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.config.src !== this.props.config.src || nextProps.config.srcId !== this.props.config.srcId)    {
            this.updateSrc(nextProps);
        }

        if(nextProps.config.privacySrc !== this.props.config.privacySrc || nextProps.config.privacySrcId !== this.props.config.privacySrcId)    {
            this.updatePrivacySrc(nextProps);
        }

        if(nextProps.config.noAcceptTermsCheckbox !== this.props.config.noAcceptTermsCheckbox)  {
            this.updateCanSend(nextProps);
        }

        if(this.timeout && this.shouldOpenAtStartUp() != this.shouldOpenAtStartUp(nextProps))   {
            this.setState({willOpenAtStartUp: this.shouldOpenAtStartUp(nextProps)});
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);

        //
        this.setState({willOpenAtStartUp: this.shouldOpenAtStartUp()});
        this.timeout = setTimeout(this.onTimeout.bind(this), 500);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);

        //
        if(this.timeout)    {
            clearTimeout(this.timeout);
            this.timeout = 0;
        }
    }

    shouldOpenAtStartUp(props)   {
        return LocalStorage.getItem('termsWereAccepted') !== 'true';
    }

    onTimeout() {
        this.timeout = 0;

        if(!this.ref)   {
            this.timeoutCall = true;
            return;
        }

        if(this.oe.isReady() && this.shouldOpenAtStartUp())   {
            this.ref.setOpen(true);
        }
        this.setState({willOpenAtStartUp: false});

        this.timeoutCall = false;
    }

    setForm(form)   {
        if(typeof(form) !== 'object')   return;
        const form_ = OEToolbox.filterObject(form, ['name', 'email', 'institution']);
        const newForm = Object.assign({}, this.form, form_);
        if(OEToolbox.shallowEqual(this.form, newForm, true))    return;
        this.form = newForm;
        this.onFormChanged();
    }

    onFormChanged() {
        this.updateCanSend();
    }

    updateCanSend(props) {
        props = props || this.props;
        let canSend = this.form.name && this.form.email && this.form.institution && (props.config.noAcceptTermsCheckbox || this.termsAccepted) && this.privacyTermsAccepted;
        if(this.canSend === canSend)    return;
        this.canSend = canSend;
        this.setState({canSend: this.canSend});
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({strings: {
            name:               si.getLocalizedStringEnc('register_view_name'),
            email:              si.getLocalizedStringEnc('register_view_email'),
            institution:        si.getLocalizedStringEnc('register_view_institution'),
            acceptTerms:        si.getLocalizedStringEnc('register_view_accept_terms'),
            sendBtn:            si.getLocalizedStringEnc('register_view_send')
        }});

        this.updateSrc();
        this.updatePrivacySrc();
    }

    translateSrc(src, srcId)    {
        if(srcId) {
            let src = this.oe.sharedInterface.getLocalizedStringEnc(srcId);
            return 'app/oe/' + this.oe.Module.filePackagePathURL + src;
        } else {
            return src;
        }
    }

    updateSrc(props) {
        if(!this.oe.isReady())  return;
        props = props || this.props;
        this.setState({src: this.translateSrc(props.config.src, props.config.srcId)});
    }

    updatePrivacySrc(props) {
        if(!this.oe.isReady())  return;
        props = props || this.props;
        this.setState({privacySrc: this.translateSrc(props.config.privacySrc, props.config.privacySrcId)});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    updateStyle()  {
        if(!this.sizes.form || !this.sizes.textViewContent || !this.sizes.bottom)   return;
        let privacyTextViewContentHeight = this.sizes.privacyTextViewContent ? this.sizes.privacyTextViewContent.h : 0;
        let height = `calc(${this.sizes.form.h + this.sizes.textViewContent.h + privacyTextViewContentHeight + this.sizes.bottom.h}px + 1em)`;
        privacyTextViewContentHeight = `calc(${privacyTextViewContentHeight}px)`;
        this.setState({style: {height: height}, privacyStyle: {height: privacyTextViewContentHeight}});
    }

    onFormResize(sender, size)  {
        this.sizes.form = size;
        this.updateStyle();
    }

    onTextViewContentResize(sender, size)  {
        this.sizes.textViewContent = size;
        this.updateStyle();
    }

    onPrivacyTextViewContentResize(sender, size)    {
        this.sizes.privacyTextViewContent = size;
        this.updateStyle();
    }

    onBottomResize(sender, size)  {
        this.sizes.bottom = size;
        this.updateStyle();
    }

    onWaitingControllerRef(ref) {
        this.waitingController = ref;
    }

    onRef(ref)  {
        this.ref = ref;
        if(this.props.fref) this.props.fref(ref);
        if(ref && this.timeoutCall) this.onTimeout();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEStdModalController 
                    moduleId={this.props.moduleId}
                    className="clear-backdrop center fit-content register-view"
                    style={this.state.style}
                    noHeader={true}
                    isOpen={this.props.isOpen}
                    keyboard={this.props.devFeatures}
                    hasCloseBtn={false}
                    onOpenStateChanged={this.props.onOpenStateChanged}
                    onToggle={this.props.onToggle}
                    ref={this.onRef}
                >

                    <OEThemeWaitingController options={{dim: false}} ref={this.onWaitingControllerRef}/>

                    <OETextView
                        moduleId={this.props.moduleId}
                        className="diclaimer"
                        src={this.state.src}
                        onContentSizeChanged={this.onTextViewContentResize}
                    />

                    <Form className="form">
                        <OEResizeObserver onResize={this.onFormResize}/>
                        <FormGroup>
                            <Label for="name">
                                {this.state.strings.name}
                            </Label>
                            <Input id="name" name="name" type="text" onChange={this.onNameInputChange}/>
                        </FormGroup>

                        <FormGroup>
                            <Label for="email">
                                {this.state.strings.email}
                            </Label>
                            <Input id="email" name="email" type="email" onChange={this.onEmailInputChange}/>
                        </FormGroup>

                        <FormGroup>
                            <Label for="institution">
                                {this.state.strings.institution}
                            </Label>
                            <Input id="institution" name="institution" type="text" onChange={this.onInstitutionInputChange}/>
                        </FormGroup>
                    </Form>

                    <div className="privacy-diclaimer-container" style={this.state.privacyStyle}>
                        <OECustomCheckbox className="privacy-terms-accept-cb" checked={this.state.privacyTermsAccepted} onPressed={this.onPrivacyAcceptTermsClicked}/>
                        <OETextView
                            moduleId={this.props.moduleId}
                            className="privacy-diclaimer"
                            src={this.state.privacySrc}
                            onContentSizeChanged={this.onPrivacyTextViewContentResize}
                        />
                    </div>

                    <div className="bottom">
                        <OEResizeObserver onResize={this.onBottomResize}/>

                        {this.props.config.noAcceptTermsCheckbox ? null :
                            <div className="check-box-container">
                                <OECustomCheckbox className="terms-accept-cb" checked={this.state.termsAccepted} onPressed={this.onAcceptTermsClicked}/>
                                <span>{this.state.strings.acceptTerms}</span>
                            </div>
                        }

                        <OEButtonControl className="send-btn" disabled={!this.state.canSend} onPressed={this.onSendBtnPressed}>{this.state.strings.sendBtn}</OEButtonControl>

                    </div>

                    <OEBlurModalBackdropLayer/>

                    <OECoreHideLayer moduleId={this.props.moduleId} hideFlags={this.props.config.coreHideFlags}/>

                </OEStdModalController>

                <OECoreHideLayer moduleId={this.props.moduleId} hideFlags={this.state.willOpenAtStartUp ? this.props.config.coreHideFlags : 0}/>

            </React.Fragment>
        );
    }

    onNameInputChange(e) {
        this.setForm({name: e.target.value});
    }

    onEmailInputChange(e) {
        this.setForm({email: e.target.value});
    }

    onInstitutionInputChange(e) {
        this.setForm({institution: e.target.value});
    }

    onAcceptTermsClicked()    {
        this.termsAccepted = !this.termsAccepted;
        this.setState({termsAccepted: this.termsAccepted});
        this.updateCanSend();
    }

    onPrivacyAcceptTermsClicked()    {
        this.privacyTermsAccepted = !this.privacyTermsAccepted;
        this.setState({privacyTermsAccepted: this.privacyTermsAccepted});
        this.updateCanSend();
    }

    onSendBtnPressed() {
        if(!this.canSend)   return;

        if(this.waitingController)  this.waitingController.show();

        let termsAccepted = (this.props.config.noAcceptTermsCheckbox || this.termsAccepted) && this.privacyTermsAccepted;
        let request = OEUserService.registerUserInstitution(Object.assign({}, this.form, {termsAccepted: termsAccepted}));

        request.then(result => {
            if(this.waitingController)  this.waitingController.hide();

            //
            if(result.result == OEUserServiceResultType.ok)  {
                LocalStorage.setItem('termsWereAccepted', termsAccepted ? 'true' : 'false');

                if(this.ref)    this.ref.setOpen(false);

                if(this.props.config.showStartView && LocalStorage.getItem('dontShowStartViewAtStartUp') !== 'true' && this.props.appComponent && this.props.appComponent.uiLayer && this.props.appComponent.uiLayer.startView) {
                    this.props.appComponent.uiLayer.startView.setOpen(true);
                }

                return;
            }

            //
            if(!this.oe.isReady() || !this.props.appComponent)  return;
            let si = this.oe.sharedInterface;
            
            //
            let buttons = (id, container) => [{title: si.getLocalizedStringEnc('alert_ok'), onClick: () => { container.closeModal(id) }, className: 'btn-primary'}];

            let resultType = OEToolbox.lowerCamelCaseToLowercaseUnderscore(result.result);

            this.props.appComponent.module.addModal(
                si.getLocalizedStringEnc('alert_error_title'),
                si.getLocalizedStringEnc('alert_msg_register_user_inst_request_' + resultType),
                buttons
            );
        });
    }
}

OERegisterView.defaultProps = {
    moduleId:               '',
    config:                 OEWelcomeViewConfigFactory.buildStdConfig(),
    devFeatures:            false
};

OERegisterView.propTypes = {
    moduleId:               PropTypes.string,
    isOpen:                 PropTypes.bool,
    onOpenStateChanged:     PropTypes.func,
    onToggle:               PropTypes.func,
    fref:                   PropTypes.func,
    config:                 OEWelcomeViewProps.config,
    devFeatures:            PropTypes.bool
};

//
export default frefFromRef(OERegisterView);